import { render, staticRenderFns } from "./temphum.vue?vue&type=template&id=47f8b149"
import script from "./temphum.vue?vue&type=script&lang=js"
export * from "./temphum.vue?vue&type=script&lang=js"
import style0 from "./temphum.vue?vue&type=style&index=0&id=47f8b149&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports